import React from 'react';
interface DiaryEntryProps {
  date: string;
  title: string;
  children: React.ReactNode;
}
export function DiaryEntry({
  date,
  title,
  children
}: DiaryEntryProps) {
  return <article className="relative bg-card rounded-xl p-6 md:p-8 mb-8 shadow-diary border border-brown/5" data-id="element-73">
      <div className="absolute top-0 left-0 w-1.5 h-full bg-forest/80 rounded-l-xl" data-id="element-74"></div>

      <div className="mb-4" data-id="element-75">
        <span className="inline-block font-handwriting text-xl text-brown/70 -rotate-2 mb-2" data-id="element-76">
          {date}
        </span>
        <h3 className="font-serif text-xl md:text-2xl font-bold text-forest" data-id="element-77">
          {title}
        </h3>
      </div>

      <div className="font-serif text-text/90 leading-relaxed space-y-4" data-id="element-78">
        {children}
      </div>
    </article>;
}